/**
 * PMC legal destinations used by Eater, SB Nation, and The Verge footers.
 */
export const PMC_LEGAL_URLS = {
  termsOfUse: "https://www.pmc.com/terms-of-use/",
  privacyPolicy: "https://www.pmc.com/privacy-policy/",
  californiaPrivacyRights: "https://www.pmc.com/privacy-policy#appendix",
  /** CCPA "Your Privacy Choices" destination (same page as California rights). */
  yourPrivacyChoices: "https://www.pmc.com/privacy-policy#appendix",
  cookieNotice: "https://www.pmc.com/privacy-policy#cookie-notice",
  adChoices: "https://optout.aboutads.info/?locale=en-US",
  accessibility: "https://www.pmc.com/accessibility",
} as const;
